import { render, staticRenderFns } from "./create-store.vue?vue&type=template&id=44864a5e&scoped=true"
import script from "./create-store.vue?vue&type=script&lang=js"
export * from "./create-store.vue?vue&type=script&lang=js"
import style0 from "./create-store.vue?vue&type=style&index=0&id=44864a5e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44864a5e",
  null
  
)

export default component.exports